import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=764a9556&scoped=true"
import script from "./CustomerInfo.vue?vue&type=script&lang=js"
export * from "./CustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfo.vue?vue&type=style&index=0&id=764a9556&prod&scoped=true&lang=css"
import style1 from "./CustomerInfo.vue?vue&type=style&index=1&id=764a9556&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a9556",
  null
  
)

export default component.exports